@use '@/scss/underscore' as _;

.roleUsersTransfer {
  height: 360px;
}
